import { Component, Input, Output, OnDestroy, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '~env/environment';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BuyerState } from '~app/modules/generic/store';
import * as fromStoryblok from '~app/modules/storyblok/store';
import { PromoWidgetLinkBlok } from '~app/modules/storyblok/models/storyblok-global-content.model';
import { MOBILE_IMAGE_SRC } from '~app/modules/generic/constants/promo-image-link.constants';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import {
  PromoImageLinkClickApplicationEvent
} from '~shared/modules/application-event/models/promo-image-link-click-event.model';
import { StoryData } from 'storyblok-js-client';

@Component({
  selector: 'app-promo-image-link',
  templateUrl: './promo-image-link.component.html',
  styleUrls: ['./promo-image-link.component.scss'],
})
export class PromoImageLinkComponent implements OnDestroy {
  @Output() menuClosed = new EventEmitter<null>();

  promoImageLink: PromoWidgetLinkBlok;
  marketplaceLink = environment.appBaseUrl();

  private readonly destroySubject = new Subject<boolean>();

  constructor(
    private store: Store<BuyerState>,
    private router: Router,
    private applicationEventService: ApplicationEventService
  ) {
    this.store
      .pipe(select(fromStoryblok.getPromoWidgetLink), takeUntil(this.destroySubject))
      .subscribe((promoImageLinkStory: StoryData) => {
        this.promoImageLink = promoImageLinkStory?.content?.global?.[0];
      });
  }

  getImageSrc(src: string): string {
    return MOBILE_IMAGE_SRC.replace('{src}', src);
  }

  navigateToLink(): void {
    this.firePromoImageLinkClickEvent();
    this.closeMenu();

    window.location.href = this.marketplaceLink + this.promoImageLink.link;
  }

  closeMenu(): void {
    this.menuClosed.emit();
  }

  firePromoImageLinkClickEvent(): void {
    this.applicationEventService.publish(
      new PromoImageLinkClickApplicationEvent(this.promoImageLink.link, this.router.url)
    );
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
